import React from 'react';
import './footer.scss';
import logoWhite from '../assets/img/logo-rimac-white.svg';
export const Footer = () => {
  return (

    <footer>

      <div className="container">
        <div className="logo">
          <img src={ logoWhite } alt="Rimac" />
        </div>

        <div className="copy">
          © 2023 RIMAC Seguros y Reaseguros.
        </div>
      </div>



    </footer>
  )
}
